import { render, staticRenderFns } from "./TextLong.vue?vue&type=template&id=4021345a&"
import script from "./TextLong.vue?vue&type=script&lang=js&"
export * from "./TextLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports